<div class="back-to-top position-fixed" (click)="scrollToTop()" id = 'back-to-top' *ngIf="showBackToTop">
    <a href="javascript:void(0)">
        <img src='assets/images/back-to-top.svg' alt="back to top icon"/>
        <span class="visually-hidden">back to top</span>
    </a>
</div>
